module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("移除移动端页面点击延迟")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("直接使用 "), _c('code', [_vm._v("WeUI")]), _vm._v(" 样式并引入 "), _c('code', [_vm._v("fastclick")]), _vm._v(" 会导致一些点击问题，VUX 组件内部已经做了相关处理。")])]), _vm._v(" "), _c('h2', [_vm._v("引入 fastclick")]), _vm._v(" "), _c('p', [_vm._v("在"), _c('code', [_vm._v("main.js")]), _vm._v("里引用"), _c('code', [_vm._v("fastclick")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" FastClick = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'fastclick'")]), _vm._v(")\nFastClick.attach("), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("document")]), _vm._v(".body)\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// done")]), _vm._v("\n")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65f95246", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-65f95246"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/remove-click-delay-fastclick-152.vue
// module id = 2299
// module chunks = 407